<template>
    <el-pagination
      layout="prev, pager, next"
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      @current-change="onPageChange"
    />
  </template>
  
  <script setup>
  import { toRef } from 'vue'
  const emit = defineEmits(['page-change'])
  const props = defineProps({
    page: Number,
    pageSize: Number,
    total: Number
  })
  const pageSize = toRef(props, 'pageSize')
  function onPageChange(p) {
    emit('page-change', p)
  }
  </script>
  